import React, { useEffect } from "react";
import Table from "../../../../../components/coreUiTable/Table";
import { useSelector } from "react-redux";
import { cuFormat } from "../../../../../components/coreUiTable/Format";
import LoadingAnimation from "../../../../../components/loadingAnimation/loadingAnimation";
import ReactTooltip from "react-tooltip";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const PosTable = () => {
  const dispatch = useDispatch();
  const posTableData = useSelector((state) => state.numberOfActiveMembersBy.posTableData);

  useEffect(() => {
    dispatch(actionCreators.fetchPosModalData());
  }, []);

  if (!posTableData?.data) return <LoadingAnimation text="Updating data..." />;

  const addTooltip = (header, formattedValue) => (
    <span data-tip={formattedValue}>{formattedValue}</span>
  );

  const formattedSlots = cuFormat({
    customFn: (header, formattedValue) => addTooltip(header, formattedValue),
    headers: posTableData.colHeaders,
    columns: posTableData.columns
  });

  return (
    <div className="pos-table-wrapper">
      <ReactTooltip effect="solid" />

      <Table
        key="pos-table"
        cName="pos-table"
        pagination
        title=" "
        sorter
        showCount
        scopedSlots={{
          ...formattedSlots,
          ["# of Stores"]: (item) => <td style={{ width: "0" }}>{item["# of Stores"]}</td>
        }}
        table={{
          colHeaders: posTableData.colHeaders,
          data: posTableData.data
        }}
        onPageChange={() => {
          setTimeout(() => {
            ReactTooltip.rebuild();
          }, 0);
        }}
      />
    </div>
  );
};

export default PosTable;
